import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { isInViewFooterState, stepState, inquiryState, inputState, onetimeKeyState } from '../../../states/messageState'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'
import { isPhone } from '../../../util/validation'
import { putUpdatePhone } from '../../../api/contracts'
import { useCheckAddress } from '../../../hooks/useCheckAddress'

export const InputUpdatePhone: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const { checkAddress } = useCheckAddress()

  const [input, setInput] = useRecoilState(inputState)

  const inquiry = useRecoilValue(inquiryState)
  const onetimeKey = useRecoilValue(onetimeKeyState)

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**電話番号を登録させてから住所チェック */
  const handleSubmitUpdatePhone = async () => {
    const { contractId } = inquiry
    setIsInViewFooter(false)
    setInput('')

    await handleAddSenderParent('user', input)

    if (!isPhone(input)) {
      await handleAddSenderParent('bot', `正しい電話番号の形式では無いようです。`)
      await handleAddMessage('bot', '再度入力してください。')
      handleInViewFooter()
      setCurrentStep('inputUpdatePhone')
      return
    }

    await putUpdatePhone({ contractId, phone: input }, onetimeKey)
    await handleAddSenderParent('bot', `いただいた${input}に変更致します。`)
    await checkAddress(true)
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder="電話番号(ハイフン付き)"
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmitUpdatePhone()}
        onClick={handleSubmitUpdatePhone}
      />
    </FooterContent>
  )
}
